import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20inspiring%20abstract%20artistic%20background%20with%20soft%20gradients%20of%20cream%2C%20warm%20beige%2C%20and%20terracotta%20tones%2C%20gentle%20organic%20flowing%20shapes%2C%20minimalist%20and%20calming%20aesthetic%2C%20dreamy%20atmosphere%20with%20subtle%20texture%2C%20editorial%20art%20photography%20style%20with%20soft%20focus%20and%20harmonious%20composition&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="第一次指南 - 温暖的成长陪伴"
          title="第一次指南 - 从紧张到自信的蜕变"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <i className="ri-sparkling-line text-primary-400 text-sm"></i>
          <span className="text-sm text-background-50 font-medium tracking-wide">你的「第一次」成长伙伴</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight tracking-wide">
          从紧张到自信的蜕变
        </h1>

        <p className="text-base md:text-lg text-background-50/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          无论你面对的是哪种「第一次」，这里都有你需要的准备清单、心理疏导与实战技巧。告别焦虑，让每一个「第一次」都成为人生高光时刻。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/career"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/30"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/30"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { num: "200+", label: "原创文章" },
            { num: "50万+", label: "累计读者" },
            { num: "6", label: "内容分类" },
            { num: "98%", label: "好评率" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                {stat.num}
              </div>
              <div className="text-xs md:text-sm text-background-50/70 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}